import apiClient from "./axios"

export const getAccountPaymentMethodList = async (params = {}) => {
  const { data } = await apiClient.get("/account-payment-methods", { params })
  return data
}

export const getAccountPaymentMethodById = async id => {
  const { data } = await apiClient.get(`/account-payment-methods/${id}`)
  return data
}

export const createAccountPaymentMethod = async payload => {
  const { data } = await apiClient.post("/account-payment-methods", payload)
  return data
}

export const updateAccountPaymentMethod = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-payment-methods/${id}`, payload)
  return data
}

export const deleteAccountPaymentMethod = async id => {
  const { data } = await apiClient.delete(`/account-payment-methods/${id}`)
  return data
}
